/**
 * Vuex actions for the ecare module.
 *
 * @module store/modules/ecare/actions
 */
import _ from "lodash";

import { rest } from "@/store/api";
import { RootState } from "@/store/types";
import { ActionTree } from "vuex/types";
import { EcareState } from "./types";

const actions: ActionTree<EcareState, RootState> = {
  /**
   * Fetches available Metabase dashboards from the API.
   *
   * @param {ActionContext} context - Vuex action context
   * @returns {Promise<Array>} Sorted list of dashboards
   *
   * @example
   * await this.$store.dispatch('ECARE_GET_DASHBOARDS');
   */
  ECARE_GET_DASHBOARDS: async ({ state, commit, dispatch }) => {
    const result = await rest("get", "get_metabase_dashboards");
    commit("ECARE_SET_DASHBOARDS", _.sortBy(result, ["id"]));
    return result;
  },

  /**
   * Sets the currently selected tab.
   *
   * @param {ActionContext} context - Vuex action context
   * @param {string} payload - Tab identifier
   * @returns {Promise<void>}
   */
  ECARE_SET_SELECTED_TAB: async ({ state, commit, dispatch }, payload) => {
    commit("ECARE_SET_SELECTED_TAB", payload);
  },

  /**
   * Sets the editor visibility state.
   *
   * @param {ActionContext} context - Vuex action context
   * @param {boolean} payload - Visibility flag
   * @returns {Promise<void>}
   */
  ECARE_SET_EDITOR_VISIBLE: async ({ state, commit, dispatch }, payload) => {
    commit("ECARE_SET_EDITOR_VISIBLE", payload);
  },

  /**
   * Toggles the editor visibility state.
   *
   * @param {ActionContext} context - Vuex action context
   * @returns {Promise<void>}
   */
  ECARE_TOGGLE_EDITOR_VISIBLE: async ({ state, commit, dispatch }) => {
    commit("ECARE_TOGGLE_EDITOR_VISIBLE");
  },
};

export default actions;
